/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TechwatchRouteImport } from './routes/techwatch'
import { Route as MemesRouteImport } from './routes/memes'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PostSlugRouteImport } from './routes/post.$slug'

const TechwatchRoute = TechwatchRouteImport.update({
  id: '/techwatch',
  path: '/techwatch',
  getParentRoute: () => rootRouteImport,
} as any)
const MemesRoute = MemesRouteImport.update({
  id: '/memes',
  path: '/memes',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PostSlugRoute = PostSlugRouteImport.update({
  id: '/post/$slug',
  path: '/post/$slug',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/memes': typeof MemesRoute
  '/techwatch': typeof TechwatchRoute
  '/post/$slug': typeof PostSlugRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/memes': typeof MemesRoute
  '/techwatch': typeof TechwatchRoute
  '/post/$slug': typeof PostSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/memes': typeof MemesRoute
  '/techwatch': typeof TechwatchRoute
  '/post/$slug': typeof PostSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/memes' | '/techwatch' | '/post/$slug'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/memes' | '/techwatch' | '/post/$slug'
  id: '__root__' | '/' | '/memes' | '/techwatch' | '/post/$slug'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  MemesRoute: typeof MemesRoute
  TechwatchRoute: typeof TechwatchRoute
  PostSlugRoute: typeof PostSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/techwatch': {
      id: '/techwatch'
      path: '/techwatch'
      fullPath: '/techwatch'
      preLoaderRoute: typeof TechwatchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/memes': {
      id: '/memes'
      path: '/memes'
      fullPath: '/memes'
      preLoaderRoute: typeof MemesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/post/$slug': {
      id: '/post/$slug'
      path: '/post/$slug'
      fullPath: '/post/$slug'
      preLoaderRoute: typeof PostSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  MemesRoute: MemesRoute,
  TechwatchRoute: TechwatchRoute,
  PostSlugRoute: PostSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
